import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService extends DataService {
  private baseURI = this.publicApiUri + '/user/forgot';

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  getUserQuestion(email: string): Observable<any> {
    this.setUri(this.publicApiUri + '/user/question/' + email);
    const observableResponse: Observable<any> = this.get();
    this.setUri(this.baseURI);
    return observableResponse;
  }

}
